var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIsSubmitedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 .25C6.406.25.25 6.406.25 14S6.406 27.75 14 27.75 27.75 21.594 27.75 14 21.594.25 14 .25zm5.96 11.425a1.25 1.25 0 10-1.92-1.6l-5.375 6.449-2.781-2.783a1.25 1.25 0 00-1.768 1.768l3.75 3.75a1.25 1.25 0 001.844-.084l6.25-7.5z",
    fill: "#ED1B2E"
  })));
}

export default SvgIsSubmitedIcon;